module.exports = __webpack_public_path__ + "img/easy-ice-cream.d0011319.jpg";